import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { PATH_TIME_TYPES } from '@/lib/constants/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import updateStatus from '@/store/helpers/updateStatus'
import buildInitialState from '@/store/helpers/buildInitialState'
import { notifyError } from '@/lib/notifications'

const timeTypes = {
  namespaced: true,
  state: buildInitialState({
    timeTypesList: []
  }),
  getters: {
    getField
  },
  mutations: {
    updateStatus,
    updateField,
    setTimeTypes: (state, timeTypes) => {
      state.timeTypesList = timeTypes
    }
  },
  actions: {
    getTimeTypes: ({ commit, dispatch }) => {
      commit('updateStatus', { status: IN_PROGRESS })

      // Inactive types are kept so stored hours on a deactivated Time Off type still total as Time
      // Off; offering paths filter on `active` themselves.
      return api.doGet({ path: PATH_TIME_TYPES })
        .then(json => json.data)
        .then(timeTypes => {
          commit('updateStatus', { status: COMPLETE })
          commit('setTimeTypes', timeTypes)
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to load time types. Overtime rate fields and Time Off totals may be wrong - reload the page and try again.')
        })
    }
  }
}

export default timeTypes
